import projection from '../generated/pwn211f1.json';
import { AcceptanceManifest } from '../types';
export const pwn211f1AcceptanceManifest = projection as AcceptanceManifest;
